import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function Signup() {
  const { register, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to Sarees by Raunak");
      nav("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid lg:grid-cols-2" data-testid="signup-page">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1400" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/60" />
        <div className="relative z-10 h-full flex items-end p-12 text-[#fcfbf8]">
          <div>
            <Logo variant="light" />
            <p className="font-italic-serif text-3xl mt-6 max-w-md">Begin your journey with heirloom weaves.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 bg-[#fcfbf8]">
        <div className="w-full max-w-sm">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#c9a34a] mb-3">Join Us</div>
          <h1 className="font-serif text-4xl text-[#2b1b1c] mb-8">Create your account</h1>

          <button onClick={loginWithGoogle} className="w-full border border-[#e8e4db] py-3 hover:border-[#7a1e2b] transition-colors flex items-center justify-center gap-3" data-testid="google-signup-btn">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
            <span className="text-sm">Continue with Google</span>
          </button>

          <div className="my-6 flex items-center gap-4 text-xs text-[#7c7273] tracking-widest uppercase">
            <div className="flex-1 h-px bg-[#e8e4db]" /> or <div className="flex-1 h-px bg-[#e8e4db]" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <Input placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} className="rounded-none" data-testid="signup-name" required />
            <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none" data-testid="signup-email" required />
            <Input type="password" placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none" data-testid="signup-password" required minLength={6} />
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="signup-submit">{loading ? "Creating…" : "Create account"}</button>
          </form>

          <p className="text-sm text-[#7c7273] mt-6 text-center">
            Already have an account? <Link to="/login" className="text-[#7a1e2b] link-underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
